import classNames from 'classnames';
import React, { FC, useMemo } from 'react';
import { Accordion } from '../Accordion';
import { ContentBox } from '../ContentBox';
import styles from './SelectableToggleBox.module.scss';
import { SelectableToggleBoxBody } from './SelectableToggleBoxBody';
import { SelectableToggleBoxContext } from './SelectableToggleBoxContext';
import { SelectableToggleBoxHeading } from './SelectableToggleBoxHeading';
import { SelectableToggleBoxLabel } from './SelectableToggleBoxLabel';

export type SelectableToggleBoxProps = {
	open?: boolean;
	defaultOpen?: boolean;
	selected?: boolean;
	size?: 'xs' | 'sm' | 'md';
	className?: string;
};

export const SelectableToggleBox: FC<SelectableToggleBoxProps> = ({ open, defaultOpen, selected, size = 'md', className, children }) => {
	const context = useMemo(() => ({ size }), [size]);

	return (
		<SelectableToggleBoxContext.Provider value={context}>
			<Accordion
				as={ContentBox}
				className={classNames(styles.selectableToggleBox, 'selectableToggleBox mb-last-0 position-relative', className, {
					['py-xl-7 px-xl-10']: size === 'md',
				})}
				activeKey={open ? '0' : undefined}
				defaultActiveKey={defaultOpen ? '0' : ''}
				outline
				selected={selected}
			>
				<Accordion.Item eventKey="0">{children}</Accordion.Item>
			</Accordion>
		</SelectableToggleBoxContext.Provider>
	);
};

export default Object.assign(SelectableToggleBox, {
	Body: SelectableToggleBoxBody,
	Heading: SelectableToggleBoxHeading,
	Label: SelectableToggleBoxLabel,
});
